import React from "react";
import { Helmet } from "react-helmet";
import {
    createMuiTheme,
    MuiThemeProvider,
    responsiveFontSizes,
} from "@material-ui/core/styles";

const myTheme = createMuiTheme({
    palette: {
        primary: {
            main: "#19c686",
        },
        secondary: {
            main: "#f4516d",
        },
    },
    typography: {
        fontFamily: `'Montserrat', sans-serif`,
    },
});
myTheme.shadows[1] =
    "0px 1px 1px 0px rgba(0,0,0,0.1),0px 1px 0px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)";


const theme = responsiveFontSizes(myTheme);

export interface ThemeProps {
    children: any;
}

const Theme: React.FC<ThemeProps> = ({ children }) => {
    return (
        <>
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Montserrat&display=swap"
                    rel="stylesheet"
                />
                <link
                    rel="stylesheet"
                    href="https://fonts.googleapis.com/icon?family=Material+Icons"
                    media="all"
                />
            </Helmet>
            <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
        </>
    );
};

export default Theme;
